import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";
import { scrollToId } from "@/lib/scroll";
import site from "@/data/site.json";
import products from "@/data/products.json";

export default function Categories({ onPick }) {
    return (
        <section id="categorias" data-testid="categories-section" className="relative py-20 lg:py-28">
            <div className="container-x">
                <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
                    <SectionHeading
                        eyebrow="Categorias"
                        title={
                            <>
                                Escolhido com cuidado, <em className="text-coral">mimado com amor</em>
                            </>
                        }
                        description="Cinco universos de cuidado para explorar — toque em uma categoria para filtrar o catálogo."
                    />
                    <Reveal delay={0.2} className="hidden md:block">
                        <button
                            type="button"
                            data-testid="categories-view-all-button"
                            onClick={() => onPick("todos")}
                            className="group inline-flex items-center gap-2 text-sm font-bold text-forest transition-colors hover:text-coral-dark"
                        >
                            Ver tudo
                            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                        </button>
                    </Reveal>
                </div>

                <div className="mt-10 grid grid-cols-2 gap-4 sm:gap-6 md:grid-cols-3 lg:grid-cols-5">
                    {site.categories.map((cat, i) => {
                        const count = products.filter((p) => p.categories.includes(cat.id)).length;
                        return (
                            <Reveal key={cat.id} delay={0.08 * i} className="h-full">
                                <button
                                    type="button"
                                    data-testid={`category-card-${cat.id}`}
                                    onClick={() => onPick(cat.id)}
                                    className="group relative flex h-full w-full flex-col overflow-hidden rounded-[1.75rem] border border-sand bg-cream-card text-left shadow-sm transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_48px_rgba(23,61,53,0.14)]"
                                >
                                    <div className="relative aspect-[4/3] overflow-hidden">
                                        <img
                                            src={cat.image}
                                            alt={cat.label}
                                            loading="lazy"
                                            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                                        />
                                        <div
                                            className="absolute inset-0 bg-gradient-to-t from-forest/40 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100"
                                            aria-hidden="true"
                                        />
                                    </div>
                                    <div className="flex flex-1 flex-col gap-0.5 p-4">
                                        <span className="font-serif text-lg font-bold text-forest">{cat.label}</span>
                                        <span className="text-xs text-graphite-muted">{cat.description}</span>
                                        <span className="mt-2 text-[10px] font-bold uppercase tracking-[0.2em] text-coral">
                                            {count} produto{count !== 1 ? "s" : ""} demo
                                        </span>
                                    </div>
                                </button>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
